import styled from 'styled-components';

export const ReportsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ReportCard = styled.div`
  padding: 12px;
  background-color: ${({ theme }) => theme.colors.black1};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.black3};
`;

export const ReportCardRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ReportCardLabel = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.black7};
`;

export const ReportCardValue = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.black9};
  word-break: break-word;
`;
